/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatchProductsRequestInnerAllOfSchedulesInnerDaysInner } from './PatchProductsRequestInnerAllOfSchedulesInnerDaysInner';
import {
    PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerFromJSON,
    PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerFromJSONTyped,
    PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerToJSON,
    PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerToJSONTyped,
} from './PatchProductsRequestInnerAllOfSchedulesInnerDaysInner';

/**
 * 
 * @export
 * @interface GetWorkingTimes200ResponseLocationMondayInner
 */
export interface GetWorkingTimes200ResponseLocationMondayInner {
    /**
     * 
     * @type {string}
     * @memberof GetWorkingTimes200ResponseLocationMondayInner
     */
    id: string;
    /**
     * 
     * @type {PatchProductsRequestInnerAllOfSchedulesInnerDaysInner}
     * @memberof GetWorkingTimes200ResponseLocationMondayInner
     */
    day: PatchProductsRequestInnerAllOfSchedulesInnerDaysInner;
    /**
     * 
     * @type {string}
     * @memberof GetWorkingTimes200ResponseLocationMondayInner
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof GetWorkingTimes200ResponseLocationMondayInner
     */
    end: string;
}

/**
 * Check if a given object implements the GetWorkingTimes200ResponseLocationMondayInner interface.
 */
export function instanceOfGetWorkingTimes200ResponseLocationMondayInner(value: object): value is GetWorkingTimes200ResponseLocationMondayInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('day' in value) || value['day'] === undefined) return false;
    if (!('start' in value) || value['start'] === undefined) return false;
    if (!('end' in value) || value['end'] === undefined) return false;
    return true;
}

export function GetWorkingTimes200ResponseLocationMondayInnerFromJSON(json: any): GetWorkingTimes200ResponseLocationMondayInner {
    return GetWorkingTimes200ResponseLocationMondayInnerFromJSONTyped(json, false);
}

export function GetWorkingTimes200ResponseLocationMondayInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetWorkingTimes200ResponseLocationMondayInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'day': PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerFromJSON(json['day']),
        'start': json['start'],
        'end': json['end'],
    };
}

export function GetWorkingTimes200ResponseLocationMondayInnerToJSON(json: any): GetWorkingTimes200ResponseLocationMondayInner {
    return GetWorkingTimes200ResponseLocationMondayInnerToJSONTyped(json, false);
}

export function GetWorkingTimes200ResponseLocationMondayInnerToJSONTyped(value?: GetWorkingTimes200ResponseLocationMondayInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'day': PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerToJSON(value['day']),
        'start': value['start'],
        'end': value['end'],
    };
}

